import QuestCreateUpdate from "./QuestCreateUpdate.jsx";
import ListQuest from "./ListQuest.jsx";

export default {
  QuestCreateUpdate,
  ListQuest
}
